// 2025090719: needs to keep the agency selected if in ls or state
import React from 'react';
import PropTypes from 'prop-types';
import Agency from './Agency'; // xt I think this should be nameed AgencyListItem,since it builds a list to choose

const AgencyList = ({ pathRef, agencies, languageCode }) => (
  <div className="d-flex justify-content-center">
    <ul className="list-group" style={{ maxWidth: '500px' }}>
      {agencies.map((agency) => (
        <Agency
          key={agency._id}
          agency={agency}
          languageCode={languageCode}
          pathRef={pathRef}
        />
      ))}
    </ul>
  </div>
);

AgencyList.propTypes = {
  pathRef: PropTypes.string.isRequired,
  agencies: PropTypes.array.isRequired,
  languageCode: PropTypes.string.isRequired,
};

export default AgencyList;